<template>
  <div class="vedio-box">
    <div v-for="(v, i) in vedios" :key="v.id" class="vedio-item">
      <div class="top-line">
        <p>{{v.title}}</p>
        <div class="btns" v-if="isEdit">
          <span v-if="i!==0" @click="moveUp(v, i)">上移</span>
          <span v-if="i+1<vedios.length" @click="moveDown(v, i)">下移</span>
          <span class="edit" @click="handleEdit(v.id)">修改</span>
        </div>
      </div>
      <VideoPlayer :videoUrl="videoUrl[v.filePath]"/>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer';
import { packgeServer } from '@/api/api'
export default {
  components: {VideoPlayer},
  props: {
    vedios: {
      type: Array,
      required: false
    },
    videoUrl: {
      type: Object,
      required: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    moveUp (item, index) {
      const json = [
        {id: item.id, sort: this.vedios[index - 1].sort === item.sort ? this.vedios[index - 1].sort + 5 : this.vedios[index - 1].sort},
        {id: this.vedios[index - 1].id, sort: item.sort}
      ]
      packgeServer.vedioSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    moveDown (item, index) {
      const json = [
        {id: item.id, sort: this.vedios[index + 1].sort === item.sort ? this.vedios[index + 1].sort - 5 : this.vedios[index + 1].sort},
        {id: this.vedios[index + 1].id, sort: item.sort}
      ]
      packgeServer.vedioSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    handleEdit (id) {
      let rourteUrl = this.$router.resolve({
        path: '/resource/addvedioIndex',
        query: {id: id}
      });
      window.open(rourteUrl.href, '_blank')
    },
  }
}
</script>

<style scoped lang='scss'>
.vedio-box {
  margin-top: 10px;
  line-height: 30px;
  .vedio-item {
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .top-line {
    position: relative;
    text-align: left;
    p {
      display: inline-block;
      width: calc(100% - 125px);
      font-size: 16px;
      font-weight: 600;
    }
    .btns {
      display: inline-block;
      position: absolute;
      right: 0;
      span {
        padding: 0 5px;
        color: #409eff;
        cursor: pointer;
      }
      .edit {
        color: #95d1a3;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coursePackage/components/vedio.vue